import { Box, Typography } from '@mui/material'
import { NunaLabel } from 'components'
import { COLORS } from 'const'
import { normalTextStyle } from 'styles'

export const DescriptionSection = () => {
  return (
    <Box
      sx={{
        px: { xs: 4, md: 15 },
        py: { xs: 8, md: 15 },
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          gap: 3,
          width: '100%',
          maxWidth: { xs: '900px', lg: '75%' },
          mx: 'auto',
        }}
      >
        <Typography
          sx={{
            fontSize: 'clamp(1.8rem, 4vw, 3rem)',
            fontWeight: 800,
            fontFamily: 'Poppins',
            lineHeight: 1.1,
          }}
        >
          Tus mejores acuerdos <br />
          fírmalos con
          <Box
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              verticalAlign: 'middle',
              color: COLORS.text.nuna,
              ml: 1,
              gap: 1,
            }}
          >
            <NunaLabel
              sxImgProps={{ height: 'clamp(1.8rem, 4vw, 3rem)' }}
              sxTextProps={{
                fontSize: 'clamp(1.8rem, 3vw, 2.55rem)',
              }}
            />
          </Box>
        </Typography>

        <Typography
          sx={{
            ...normalTextStyle,
            lineHeight: 1.8,
            maxWidth: { xs: '900px', md: '690px' },
            mx: 'auto',
          }}
        >
          Te presentamos una plataforma que te permite firmar documentos en línea, interactuar con
          tus socios, clientes y proveedores. La mejor experiencia de firmar documentos.
        </Typography>
      </Box>
    </Box>
  )
}
